
import _ from 'lodash';
import {setDefaults} from "@/router/helper";
// 工厂生产
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

//这个也是工厂生产，是后续开发版本
const memberTeams= () => import('@/views/memberTeam/teams.vue');


const routes = [
  {
    path: 'memberTeams',
    meta: {
      title: '工厂组',
    },
    component: memberTeams,
  },

];



export default setDefaults(routes);
